import { Box } from "../../ui/box";
import { HStack } from "../../ui/hstack";
import { Text } from "../../ui/text";
import ElapsedHint from "./ElapsedHint";
import MontuEmblem from "./MontuEmblem";
import useElapsed from "./useElapsed";

type Props = {
  label?: string;
  /** Feeds the elapsed-time cue. 0 while idle. */
  startedAt: number;
};

/**
 * The agent is working but has not said anything yet.
 *
 * A dashed border and a white fill: visibly the least-committed of the three assistant
 * states. Previously this, the streaming bubble and a settled message were the same box,
 * so "thinking", "writing" and "said" looked identical — the one thing a chat must never
 * be ambiguous about.
 */
const ThinkingIndicator = ({ label = "Pensando…", startedAt }: Props) => {
  const elapsedMs = useElapsed(startedAt);

  return (
    <Box className="mb-3 self-start rounded-2xl rounded-bl-md border border-dashed border-outline-200 bg-background-0 px-4 py-2.5">
      <HStack space="sm" className="items-center">
        <MontuEmblem size={28} thinking />
        <Text className="text-sm text-typography-500 animate-shimmer motion-reduce:animate-none">
          {label}
        </Text>
      </HStack>
      {/* Same dead-zone cue as `AnimationSlot`'s moments — a turn can sit here just
          as long as it can sit mid-tool, and the stall notice is 90s away. */}
      <ElapsedHint elapsedMs={elapsedMs} className="mt-1" />
    </Box>
  );
};

export default ThinkingIndicator;
